
$views.teamsettings = {
	
	display : function($callback) {
		
		// display the team name editable box
		this.nameEditable = new $soupmail.control.editable({
			selector : '#teamname_editable',
			model : 'teams',
			listArrayKey : 'team',
			itemId : $models.login.getTeamid(),
			column : { name:'name', label:'Team Name:', cssclass:'', layoutView:'', layoutEdit:'', maxlength:250 },
			editingEnabled : $models.login.hasAdminPrivileges(),
			dataItemRowClass : 'teamname',
			validation : {validator: 'IMAPcompatible', failMessage: 'Please ensure you enter a team name.  Do not include any dots or slashes.'}
		});
		this.nameEditable.change(function() {
			jQuery('#teamname_editable .savebutton input').click(function() {
				if (!$views.teamsettings.nameEditable.validOrError('Please enter a valid team name.  Do not include any dots or slashes.')) {
					return false;
				}
				var newTeamName = $views.teamsettings.nameEditable.val();
				$models.teams.setItem($models.login.getTeamid(), newTeamName, function() {
					$views.teamsettings.nameEditable.val(newTeamName);
				});
			});
		});
		this.nameEditable.load();
		
		
		// display the team permissions box
		this.permissionsEditable = new $soupmail.control.editable({
			selector : '#permissions_editable',
			model : 'permissions',
			listArrayKey : 'permissions',
			itemId : 0,
			column : { name:'perms', label:'Default Permissions:', cssclass:'', layoutView:'', layoutEdit:$views.all.permissionsDropdown, maxlength:255, onAfterRender:function(permissions, obj) {
				var dropdownValue = $models.folders.decodePermsSet(permissions).decodedVal;
				if (dropdownValue === -1) {
					obj.find('.editbutton').remove();
				} else if (!dropdownValue) {
					dropdownValue = 3;
				}
				obj.find('select').val(dropdownValue);
				obj.find('.value span').text($models.folders.decodePermsSet(permissions).decodedLabel);
			} },
			editingEnabled : $models.login.hasAdminPrivileges(),
			dataItemRowClass : 'teamperms',
			validation : false
		});
		this.permissionsEditable.change(function() {
			jQuery('#permissions_editable .savebutton input').click(function() {
				var $permissions = [];
				var $newPermsValue = jQuery('#permissions_editable select').val();
				$permissions = $permissions.concat($models.folders.encodePermsSet('', $newPermsValue));
				var $permsData = JSON.stringify({ permissions: $permissions });
				$models.permissions.setItem($permsData, function() {
					$views.teamsettings.permissionsEditable.load();
				});
			});
		});
		this.permissionsEditable.load();
		
		
		// display the users grid
		this.usersGrid = new $soupmail.control.grid({
			model : 'users',
			selector : '#team_users_grid',
			listArrayKey : 'users',
			paginationFrameSize : 1000,
			columns : [
				{ name:'display_name', hidden:true, defaultvalue:' ' },
				{ name:'email', label:'Email address', cssclass:'teamsettings_user_email', layout:'<span>{display_name}</span> <span style="color:#888">&lt;{email}&gt;</span>' },
				{ name:'admin', label:'Admin', layout:'', cssclass:'teamsettings_user_admin', onBeforeRender:function($isAdmin, item) {
					return (item.admin ? 'Admin user' : '');
				} },
				{ name:'admindropdown', label:'Edit admin state', layout:'<select><option value="1">Admin user</option><option value="0">Regular user</option></select>', cssclass:'teamsettings_admin_chooser', onAfterRender:function(item, obj) {
					var selectedOption = (item.admin ? 1 : 0);
					obj.find('.teamsettings_admin_chooser select').val(selectedOption);
				} },
				{ name:'status', hidden:true, onAfterRender:function(item, obj) {
					if ((item.status == 'unactivated') || (item._isNewPrependedFolder)) {
						obj.addClass('unactivated-user');
						obj.find('.teamsettings_user_email').attr('title', 'Hasn\'t been activated yet').attr('rel', 'tipsy');
					} else {
						obj.find('.teamsettings_user_email').attr('title', 'Active user account').attr('rel', 'tipsy');
					}
				} },
				{ name:'delete', label:'Delete', layout:'<a href="#" rel="tipsy" onclick="return false" class="delete-button" title="Remove Team Member"></a>', cssclass:'deletebutton' },
				{ name:'edit', label:'Edit', layout:'<a href="#" rel="tipsy" onclick="return false" class="edit-button" title="Edit Team Member"></a>', cssclass:'editbutton', onAfterRender:function(item, obj) {
					if (item.id == $models.login.getUserid()) {
						obj.find('.editbutton').remove();
					}
				} },
				{ name:'reset', label:'Reset Password', layout:'<a href="#" rel="tipsy" onclick="return false" class="reset-password-button" title="Send Reset Password Email"></a>', cssclass:'resetbutton', onAfterRender:function(item, obj) {
					if (item.id == $models.login.getUserid()) {
						obj.find('.resetbutton').remove();
					}
					if (item.status == 'unactivated') {
						obj.find('.resetbutton').remove();
					}
				} },
				{ name:'save', label:'Save', layout:'<input type="button" value="Save" />', cssclass:'savebutton' },
				{ name:'cancel', label:'Cancel', layout:'<a href="#" onclick="return false" class="cancel">Cancel</a>', cssclass:'cancelbutton' },
				{ name:'', cssclass:'clearfix' }
			],
			editingEnabled : $models.login.hasAdminPrivileges(),
			deletingEnabled : $models.login.hasAdminPrivileges(),
			headersEnabled : false,
			dataWrapperElem : 'ul',
			dataRowElem : 'li',
			dataItemRowId : 'team-user-{id}',
			dataItemRowClass : 'team-user-item editable-grid-item',
			dataItemElem : 'div'
		});
		this.usersGrid.change(function() {
			
			// unbind any existing event handlers
			jQuery('.team-user-item .deletebutton').die();
			jQuery('.team-user-item .editbutton').die();
			jQuery('.team-user-item .resetbutton').die();
			jQuery('.team-user-item .savebutton').die();
			jQuery('.team-user-item .cancelbutton').die();
			jQuery('.tipsy').remove();
			
			// bind all necessary event handlers onto each of the controls
			jQuery('.team-user-item a').click(function(e) {
				e.preventDefault();
			});
			jQuery('.team-user-item .deletebutton').live("click", function() {
				var userid = jQuery(this).parent().attr('data-id');
				if (userid != $models.login.getUserid()) {
					$soupmail.modal.deletion('Removing this team member will delete their Soup Mail account. Any folders or emails owned by this user will not be removed and will still be accessible to the team.<br /><br />Are you sure you wish to remove this team member?', function() {
						$controllers.teamsettings.removeUser(userid);
					});
				} else {
					$controllers.accountremoval.display('team-settings');
				}
			});
			jQuery('.team-user-item .editbutton').live("click", function() {
				var userid = jQuery(this).parent().attr('data-id');
				$views.teamsettings.cancelUserEditingMode();
				jQuery('#team-user-'+userid+' .teamsettings_user_admin').hide();
				jQuery('#team-user-'+userid+' .deletebutton').hide();
				jQuery('#team-user-'+userid+' .editbutton').hide();
				jQuery('#team-user-'+userid+' .resetbutton').hide();
				jQuery('#team-user-'+userid+' .teamsettings_admin_chooser').show();
				jQuery('#team-user-'+userid+' .savebutton').show();
				jQuery('#team-user-'+userid+' .cancelbutton').show();
			});
			jQuery('.team-user-item .resetbutton').live("click", function() {
				var userid = jQuery(this).parent().attr('data-id');
				$controllers.teamsettings.resetPassword(jQuery('#team-user-'+userid+' .data_email').text());
			});
			jQuery('.team-user-item .savebutton').live("click", function() {
				var userid = jQuery(this).parent().attr('data-id');
				$controllers.teamsettings.updateUserAdminState(userid, jQuery('#team-user-'+userid+' .teamsettings_admin_chooser select').val());
			});
			jQuery('.team-user-item .cancelbutton').live("click", function() {
				$views.teamsettings.cancelUserEditingMode();
			});
			
		});
		this.usersGrid.load($callback);
		
		if ($models.login.hasAdminPrivileges()) {
			$views.teamsettings.renderUserChooser();
		}
		
	},
	
	cancelUserEditingMode : function() {
		jQuery('.teamsettings_user_admin, #team_users_grid .deletebutton, #team_users_grid .editbutton, #team_users_grid .resetbutton').show();
		jQuery('.teamsettings_admin_chooser, #team_users_grid .savebutton, #team_users_grid .cancelbutton').hide();
	},
	
	renderUserChooser : function() {
		
		jQuery('#add_a_user').html('<span class="add_a_user_label">Add a User:</span><div><input type="email" class="text" name="add_user_email" id="add_user_email" onfocus="if(this.value==&#39;Enter an email address&#39;){this.value=&#39;&#39;};" onblur="if(this.value==&#39;&#39;){this.value=&#39;Enter an email address&#39;};" value="Enter an email address" /></div><input type="button" value="Add" class="add_user_button" style="float:left" />');
		
		jQuery('#add_a_user #add_user_email').keyup(function(){
			if (jQuery('#add_a_user #add_user_email').val()){
				jQuery('#add_a_user #add_user_email').css({'color': '#000'});
			}else{
				jQuery('#add_a_user #add_user_email').css({'color': '#c2c2c2'});
			}
		});
		
		jQuery('#add_a_user .add_user_button').click(function() {
			$controllers.teamsettings.addUser(jQuery('#add_user_email').val());
			jQuery('#add_user_email').val('Enter an email address');
			jQuery('#add_user_email').css({'color': '#c2c2c2'});
		});
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/views/desktop.teamsettings.js